import React, {PureComponent, ReactNode} from "react"

import id from "@irati/utils/id"

import theme from "../global/theme"
import StyledBanner from "./styled/Banner"
import CutOffTriangle from "./styled/CutOffTriangle"

interface Props {
  backgroundColor: string
  backgroundPosition: string
  backgroundSize: string
  tabletBackgroundPosition: string
  tabletBackgroundSize: string
  bannerImg: string
  children: ReactNode
  minHeight: number
  tabletMinHeight: number
  cutOffBottom: boolean
  className: string
  radius: string
}

class Banner extends PureComponent<Props> {
  static defaultProps = {
    backgroundColor: theme.colors.greys.black,
    backgroundPosition: "top center",
    backgroundSize: "cover",
    tabletBackgroundPosition: "top center",
    tabletBackgroundSize: "cover",
    minHeight: 340,
    tabletMinHeight: 340,
    cutOffBottom: false,
    className: null,
    radius: null
  }

  render() {
    const {
      backgroundColor,
      backgroundPosition,
      backgroundSize,
      tabletBackgroundPosition,
      tabletBackgroundSize,
      bannerImg,
      children,
      minHeight,
      tabletMinHeight,
      cutOffBottom,
      className,
      radius
    } = this.props
    const idNamespace = id("perkbox-banner", this.props)

    return (
      <StyledBanner
        id={idNamespace}
        backgroundColor={backgroundColor}
        backgroundPosition={backgroundPosition}
        backgroundSize={backgroundSize}
        tabletBackgroundPosition={tabletBackgroundPosition}
        tabletBackgroundSize={tabletBackgroundSize}
        minHeight={minHeight}
        tabletMinHeight={tabletMinHeight}
        src={bannerImg}
        radius={radius}
        className={className}>
        {children}
        {cutOffBottom && <CutOffTriangle />}
      </StyledBanner>
    )
  }
}

export default Banner
